import { Component, Input, ViewEncapsulation } from '@angular/core';
import { TagsContext } from 'src/app/task-process/shared/tags-context.class';
import { Task } from 'src/app/tasks/shared/models';

@Component({
  selector: 'app-task-message',
  templateUrl: './task-message.component.html',
  styleUrls: ['./task-message.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class TaskMessageComponent {
  @Input() task: Task;
  @Input() tagsContext: TagsContext;
}
